import { useMemo } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

export type GlobalShortcutsItemMap = {
	[key: string]: GlobalShortcutsItem;
};

export const useOrderedAppShortcuts = (
	shortcutItemsConfig: GlobalShortcutsItemMap,
	orderedMenuConfig?: { menuId: string; visible: boolean }[],
) => {
	return useMemo(() => {
		if (!orderedMenuConfig || orderedMenuConfig.length === 0) {
			return Object.values(shortcutItemsConfig);
		}
		return orderedMenuConfig.reduce<GlobalShortcutsItem[]>((acc, value) => {
			const config = shortcutItemsConfig[value.menuId];
			if (config && value.visible) {
				acc.push(config);
			}
			return acc;
		}, []);
	}, [shortcutItemsConfig, orderedMenuConfig]);
};
